import { ImageTemplate, ImageTemplateType } from 'types/ImageTemplates';
import { get, httpDelete, patch, post } from 'api/client';
import config from 'config';

export type CreateImageTemplateParams = {
  name: string;
  type: ImageTemplateType;
  size: number;
  margin: number;
  image: File;
};

export type UpdateImageTemplateParams = {
  name?: string;
  size?: number;
  margin?: number;
};

const options = { baseURL: config.API_SERVICE_ENDPOINT };

export const ImageTemplatesApi = {
  get(pageId: number): Promise<ImageTemplate[]> {
    return get(`/pages/${pageId}/image-templates`, options);
  },

  create(
    pageId: number,
    params: CreateImageTemplateParams,
  ): Promise<ImageTemplate> {
    const data = new FormData();
    data.append('name', params.name);
    data.append('type', params.type);
    data.append('size', String(params.size));
    data.append('margin', String(params.margin));
    data.append('image', params.image);
    return post(`/pages/${pageId}/image-templates`, data, options);
  },

  update(
    templateId: number,
    params: UpdateImageTemplateParams,
  ): Promise<ImageTemplate> {
    return patch(`/image-templates/${templateId}`, params, options);
  },

  replaceImage(templateId: number, image: File): Promise<ImageTemplate> {
    const data = new FormData();
    data.append('image', image);
    return post(`/image-templates/${templateId}/image`, data, options);
  },

  delete(templateId: number): Promise<void> {
    return httpDelete(`/image-templates/${templateId}`, options);
  },
};
